export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

export function isComplexValue(value: unknown): boolean {
  return Array.isArray(value) || isRecord(value)
}

export function isPrimitiveArray(value: unknown): boolean {
  return Array.isArray(value) && value.every(item => !isComplexValue(item))
}
